import { EngineDataTypeEnum } from './AolEnums';

export class EngineData {
    runningHours: number;
    powerOutput: number;
    powerLoggedOutput: number;
    pitch: number;
    revolutionsPerMinute: number;
    consumptionHfo: number;
    consumptionMgo: number;
    type: EngineDataTypeEnum;
    engineNumber: number | undefined;

    constructor(
        runningHours: number,
        powerOutput: number,
        powerLoggedOutput: number,
        pitch: number,
        revolutionsPerMinute: number,
        consumptionHfo: number,
        consumptionMgo: number,
        type: EngineDataTypeEnum,
        engineNumber?: number
    ) {
        this.runningHours = runningHours;
        this.powerOutput = powerOutput;
        this.powerLoggedOutput = powerLoggedOutput;
        this.pitch = pitch;
        this.revolutionsPerMinute = revolutionsPerMinute;
        this.consumptionHfo = consumptionHfo;
        this.consumptionMgo = consumptionMgo;
        this.type = type;
        this.engineNumber = engineNumber ?? undefined;
    }
}
